import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const Select = (props) => {
  const value = props.defaultValue;
  const { formState: { errors }, register } = props.hookForm;

  const cn = `border ${errors && errors[props.name] ? 'border-[#ff0000] focus:border-[#ff0000]' : 'border-[#dbe3eb] focus:border-[#008AEA]'} rounded-[3px] w-full h-[46px] p-3 outline-none mt-[13px] transition-all duration-500`;

  const handleChange = useCallback((e) => {
    if (props.onChange) {
      props.onChange(e);
    } else {
      register(props.name, props.registerOptions).onChange(e);
    }
  }, []);

  return (
    <div className={`mt-[18px] ${props.className || ''}`}>
      <div className="text-left font-bold text-[14px] leading-[16px] text-black">
        {props.label}
      </div>
      <select
        autoFocus={props.autoFocus}
        name={props.name}
        className={cn}
        {...register(props.name, props.registerOptions)}
        onChange={handleChange}
      >
        <option value="">Select...</option>
        {
          props.data.map((item) => (
            value === item.value
              ? <option key={item.value} value={item.value} selected>{item.title}</option>
              : <option key={item.value} value={item.value}>{item.title}</option>
          ))
        }
      </select>
      {errors && errors[props.name]
        && (
        <div className="text-[#d71f28] text-xs mt-2">
          {errors[props.name]?.message}
        </div>
        )}
    </div>

  );
};

Select.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  autoFocus: PropTypes.bool,
  registerOptions: PropTypes.object.isRequired,
  hookForm: PropTypes.object.isRequired,
};

Select.defaultProps = {
  className: '',
  label: null,
  name: '',
  defaultValue: '',
  autoFocus: false,
};

export default Select;
